import React from 'react';
import Swal from 'sweetalert2';
import { UserIcon } from '../../../../components/IconsSVG';
import AdminDropdown from '../../../../partials/content/CustomDropdowns/AdminDropdown';
import CrudActions from '../../../../partials/datatable/CrudActions';
import Datatable from '../../../../partials/datatable/Datatable';
import { StyledTableCell, StyledTableRow } from '../../../../partials/datatable/styles';
import { MutantApiService } from '../../../../services/MutantApiService';
import store from '../../../../store/store';
import Loading from '../../../home/components/Loading';
import { format } from 'date-fns';

const initialState = {
	apikeys: [],
	reload: false,
	loading: true,
};

export default class ApikeysListing extends React.Component {
	constructor(props) {
		super(props);
		const { auth } = store.getState();

		this.api = new MutantApiService();

		this.state = {
			...initialState,
			userLogged: auth.user,
		};

		this.handleConfirmChangeStatus = this.handleConfirmChangeStatus.bind(this);
		this.formatRow = this.formatRow.bind(this);
		this.setApikeys = this.setApikeys.bind(this);
	}

	componentDidMount() {
		this.setState({ loading: false });
	}

	handleConfirmChangeStatus = async function (obj) {
		try {
			await this.setState({ loading: true });

			await this.api.makeHttpRequest({
				method: 'PUT',
				url: `/apikey/${obj.id}`,
			});

			await this.setState({ loading: false });

			await Swal.fire({
				title: 'Sucesso!',
				text: 'Status alterado com sucesso.',
				icon: 'success',
				cancelButtonText: 'Sair',
			});
		} catch (e) {
			await this.setState({ loading: false });
			await Swal.fire('Erro!', 'Erro ao alterar status.', 'error');
		} finally {
			await this.setState({ reload: !this.state.reload });
		}
	};

	setApikeys = (apikeys) => {
		this.setState({ apikeys });
	};

	handleConfirmDelete = async (id) => {
		try {
			const reqBase = { method: "DELETE", url: `/apikey/${id}/` }

			await this.api.makeHttpRequest(reqBase);
			await this.setState({ reload: !this.state.reload });
		} catch (e) {
			await Swal.fire(
				"Erro",
				"Problema ao reverter as alterações, tente mais tarde",
				"error"
			);
		}
	}

	formatRow = (apikey) => {
		const crudActions = ['edit', 'delete'];

		return (
			<StyledTableRow hover tabIndex={-1} key={apikey.id}>
				<StyledTableCell scope="row" align="left" width="50%">
					{!!apikey.service && `${apikey.service}`}
				</StyledTableCell>
				<StyledTableCell scope="row" align="left" width="20%">
					{!!apikey.expiresAt && format(new Date(apikey.expiresAt), 'dd/MM/yyyy hh:mm')}
				</StyledTableCell>
				<StyledTableCell scope="row" align="left" width="20%">
					{!!apikey.createdAt && format(new Date(apikey.createdAt), 'dd/MM/yyyy hh:mm')}
				</StyledTableCell>
				<StyledTableCell scope="row" width="10%" align="center">
					<CrudActions
						actions={crudActions}
						module="apikeys"
						id={apikey.id}
						onConfirmChangeStatus={this.handleConfirmChangeStatus}
						onConfirmDelete={this.handleConfirmDelete}
						obj={apikey}
					/>
				</StyledTableCell>
			</StyledTableRow>
		);
	};

	render() {
		window.setPageTitle('Listagem de projetos');

		const headRows = [
			{ label: 'SERVIÇO', align: "left" },
			{ label: 'DATA DE EXPIRAÇÃO', align: "left" },
			{ label: 'DATA DE CRIAÇÃO', align: "left" },
			{ label: 'AÇÕES', align: 'center' },
		];

		return (
			<>
				<Loading isLoading={this.state.loading} />
				<Datatable
					title="Api Keys"
					icon={UserIcon}
					endpoint="apikey"
					className="h-100"
					headRows={headRows}
					formatRow={this.formatRow}
					rows={this.state.apikeys}
					clietsRows={this.state.clients}
					setRows={this.setApikeys}
					reload={this.state.reload}
					placeholderSearch="Filtre por serviço"
					mobile={AdminDropdown}
					width={this.props.width}
					hiddenReload
					apikeys
					buttons={[
						{
							label: 'Adicionar',
							onClick: null,
							icone: 'add',
							path: '/dashboard/apikeys/new',
						},
					]}
				/>
			</>
		);
	}
}
